import Slider from 'rc-slider';
import { useEffect, useState } from 'react';
import { SliderProps } from '../types';

export const NewSlider = ({ handleSize = 32, min = 1, max = 10, value = 5, step = 1, onChange, label, brandColor }: SliderProps) => {
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    const handleSizeAndPositioning = (preferredDiameter: number) => {
        const marginTop = (preferredDiameter / 2 - 2) * -1;
        return {
            width: preferredDiameter,
            height: preferredDiameter,
            marginTop,
        };
    };

    const handleStyle = {
        ...handleSizeAndPositioning(handleSize),
        backgroundColor: 'white',
        border: 'none',
        filter: 'drop-shadow(0px 2px 8px rgba(52, 58, 64, 0.20))',
        opacity: 1,
    };

    const trackStyle = {
        backgroundColor: brandColor || '#00807B',
    };

    const railStyle = {
        backgroundColor: '#ADB5BD',
    };

    return (
        isClient && (
            <div>
                <label id={label} className="r-sr-only">
                    {label}
                </label>
                <Slider
                    ariaLabelledByForHandle={label}
                    min={min}
                    max={max}
                    value={value || 0}
                    step={step}
                    styles={{
                        handle: handleStyle,
                        track: trackStyle,
                        rail: railStyle,
                    }}
                    onChange={value => {
                        if (typeof value === 'number') {
                            onChange(value);
                        }
                    }}
                />
            </div>
        )
    );
};
